import {imageProviderImgProxyFactory} from '@vio/core/src/staticContent/services/imageProviderFactories'

export const imageProvider = imageProviderImgProxyFactory({
  secret: process.env.NEXT_PUBLIC_IMAGE_RESIZE_SERVICE_SECRET,
  url: process.env.NEXT_PUBLIC_IMAGE_RESIZE_SERVICE_URL
})
